<script>
	import { createEventDispatcher } from 'svelte';
	import {API,http_headers} from '../global.js'
	import {USER} from '../store.js'
	import FormaPagoTR from './forma-pago-tr.svelte'
	import FormaPagoDD from './forma-pago-dd.svelte'
	import FormaPagoTC from './forma-pago-tc.svelte'
	import Swal from 'sweetalert2'

	const dispatch = createEventDispatcher();
	
	export let cobranza = { idcliente : 0, importe:0, idmoneda:1, simbolo:'$', tipocli:'', sociedad:0, idcomplejo:0, complejo:'', cobranza:''}

	let formapago = {} 
	let cargando = ''
	let fd = {}
	let loading = false

	function cargar_forma_pago(fp){
		if (cobranza.importe<1) {
			alert("No se registran importes a Cobrar.")
		}
		formapago = JSON.parse(JSON.stringify(fp))
		formapago.importe = cobranza.importe
		formapago.estados = fp.estados
		cargando = fp.fpagotipo
	}

	$: refresh = async () => {
		let obj = {idmoneda:cobranza.idmoneda,cobranza:cobranza.cobranza,tipocli:cobranza.tipocli,idcomplejo:cobranza.idcomplejo}
		if($USER.aclist=='cliente'){
			obj.interno = 1
		}
		let params = Object.entries(obj).map(([key, val]) => `${key}=${val}`).join('&');
		//console.log(params)
		let rs = await fetch(`${API}/cliente-opciones-pago/${cobranza.idcliente}?${params}`)
		let ds = await rs.json()
		return ds
	}


	async function guardar(){
		loading = true
		fd.razonsocial = cobranza.RazonSocial
		fd.operador = $USER.username?$USER.username:'web'
		delete cobranza.RazonSocial 
		let params = {
			idcliente: cobranza.idcliente,
			concepto: fd.concepto,
			complejo: cobranza.idcomplejo,
			moneda: cobranza.idmoneda,
			importe: formapago.importe,
			costofinan: ((formapago.coef1val-1)*fd.importe).toFixed(2),
			registro: JSON.stringify(fd),
			tipo: cobranza.cobranza,
			estado:'PEND',
			estados:formapago.estados,
			idwventa : cobranza.idwventa
		}
		Swal.fire({
		  icon: 'success',
		  title: 'Pago ingresado.',
		  showConfirmButton: false,
		  timer: 1000
		})
		
		let rs = await fetch(`${API}/cliente-insertar-pago`,{
	        method:'POST',
	        headers: http_headers,
	        body: JSON.stringify(params)
	    })
		let ds = await rs.json()
		loading = false
		dispatch('close')
	}

	function cerrar(){
		dispatch('close')
	}

	function cancelar(){
		cargando = ''
	}
</script>

<div class="card mx-2 mt-4 border">
	<div class="card-header">
	    	<button class="btn btn-danger btn-sm float-end" on:click={cerrar}>&Cross;</button>
	    	<h5 class="card-title">Pago {cobranza.cobranza} - {cobranza.complejo}</h5>
	</div>
  	<div class="card-body overflow-auto">
        <!--pre>{JSON.stringify(cobranza,null,2)}</pre-->
        {#if cargando===''}
	        {#await refresh()}
				<p>Loading....</p>
	        {:then result}
	        	<h6>Importe a Pagar : {cobranza.simbolo} {cobranza.importe}</h6>
	        	{#each result.data as fp, index}
	        		<div class="row rounded pt-2 mb-2 is-hover" on:click={()=>cargar_forma_pago(fp)}>
	        			<div class="col-12">
	        				{fp.fpagodsc}
	        				{#if fp.coef1lbl!==''}
	        					<span class="px-1 rounded"  style="font-size:0.6em;color:{fp.coef1col.split(',')[0]};background-color:{fp.coef1col.split(',')[1]};">{fp.coef1lbl}</span>
	        				{/if}
	        			</div>
	        			<div style="font-size:0.8em;">{fp.cuotas} cuota{fp.cuotas>1?'s':''} de {fp.simbolo} {(cobranza.importe*fp.coef1val/fp.cuotas).toFixed(2)}</div>
						<div class="border-bottom mb-2" style="font-size:0.7em;">{fp.coef1dsc}
							{#if fp.coef1val!==1}
								 : {fp.simbolo} {((fp.coef1val-1)*cobranza.importe).toFixed(2)}
							{/if}
						</div>
	        		</div>
	        	{/each}
	        	<!--pre>{JSON.stringify(result,null,2)}</pre-->
	        {/await}
        {/if}

		{#if cargando==='TR'}
			<FormaPagoTR {cobranza} {formapago}/>
		{/if}

		{#if cargando==='TC'}
			<FormaPagoTC {cobranza} {formapago} bind:fd={fd}/>
		{/if}

		{#if cargando==='DA'}
			<FormaPagoTC {cobranza} {formapago} bind:fd={fd}/>
		{/if}

		{#if cargando==='DD'}
			<FormaPagoDD {cobranza} {formapago} bind:fd={fd}/>

		{/if}
    </div>

    <div class="card-footer text-end">
    	{#if cargando !=='' && cargando !== 'TR'}
			<button class="btn btn-primary px-4 me-4" on:click="{guardar}">Enviar</button>    		
    	{/if}
    	{#if cargando !== ''}
			<button class="btn btn-secondary px-3 me-4" on:click="{cancelar}">Cancelar</button>    		
    	{/if}
    </div>
</div>

<style>
	.card{
		position: fixed;
		top: 5%;
		left: 10%;
		height: 90%;
		width: 80%;
		min-width: 400px;
	}
</style>

